// utils/optionParser.ts
import { FieldOption } from '../types/BuilderField';

/** Slugifies a label into a field key, e.g. "First Name" -> "first_name". */
export function keyFromLabel(label: string): string {
  return label
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
}

/** Parses a newline-separated textarea into FieldOption[] ("Label|value" or just "Label"). */
export function parseOptionsText(text: string): FieldOption[] {
  return text
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => {
      const [label, value] = line.split('|').map((s) => s.trim());
      return { label, value: value || keyFromLabel(label) };
    });
}

export function optionsToText(options: FieldOption[]): string {
  return options.map((o) => `${o.label}|${o.value}`).join('\n');
}

export function generateFieldId(): string {
  return `field_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
}